<template>
  <div class="d-flex">
    <div class="d-flex justify-content-md-end">
      <v-btn
        color="nitro"
        class="text-white"
        @click="dialog = true"
      >
        Agendar horário de estudo
      </v-btn>
    </div>
    <div class="vuetify">
      <v-dialog
        v-model="dialog"
        max-width="800px"
      >
        <v-card>
          <div class="d-flex justify-content-between align-items-center pr-4">
            <PageTitle
              text=" Agendar horários de estudos"
              title-class="h5"
              :show-border-bottom="false"
            />
            <BtnClose @click="dialog = false" />
          </div>

          <hr class="m-0">

          <div class="p-4">
            <v-row>
              <v-col class="py-0">
                <p>Selecione os dias da semana e os horários ideais de estudo que nós adicionamos ao seu calendário.</p>
              </v-col>
            </v-row>

            <div>
              <v-row>
                <v-col class="d-flex flex-column flex-md-row justify-content-between">
                  <v-select
                    v-model="form.day"
                    :items="days"
                    label="Dia"
                    :item-value="'number'"
                  >
                    <template
                      slot="selection"
                      slot-scope="data"
                    >
                      {{ data.item.text }}
                    </template>
                  </v-select>
                  <v-dialog
                    ref="begin_modal"
                    v-model="begin_modal"
                    :return-value.sync="form.begin"
                    width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <span class="px-2">
                        <v-text-field
                          v-model="form.begin"
                          label="Início"
                          append-icon="fas fa-clock-o"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        />
                      </span>
                    </template>

                    <v-time-picker
                      v-if="begin_modal"
                      v-model="form.begin"
                      full-width
                      color="bg-dark-overlay"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        color="primary"
                        @click="begin_modal = false"
                      >
                        Cancelar
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.begin_modal.save(form.begin)"
                      >
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>

                  <v-dialog
                    ref="end_modal"
                    v-model="end_modal"
                    :return-value.sync="form.end"
                    width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.end"
                        label="Fim"
                        append-icon="fas fa-clock-o"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>

                    <v-time-picker
                      v-if="end_modal"
                      v-model="form.end"
                      full-width
                      color="bg-dark-overlay"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        color="primary"
                        @click="end_modal = false"
                      >
                        Cancelar
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.end_modal.save(form.end)"
                      >
                        OK
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                  <button
                    class="schedule-icon ml-2"
                    @click="saveSchedule"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="bg-success text-white"
                    >
                      <use xlink:href="#icon-plus" />
                    </svg>
                  </button>
                </v-col>
              </v-row>
            </div>

            <v-row>
              <v-col>
                <p class="font-weight-bolder mb-2">
                  Horários agendados
                </p>
                <ul class="list-unstyled list-schedule">
                  <li
                    v-for="(schedule, index) in schedules"
                    :key="index"
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span>
                      {{
                        days[schedule.day - 1].text
                      }}, de {{ schedule.begin.split(':')[0] }}h
                      {{
                        schedule.begin.split(':')[1]
                      }}min as {{ schedule.end.split(':')[0] }}h{{ schedule.end.split(':')[1] }}min
                    </span>
                    <button
                      class="schedule-icon"
                      @click="deleteSchedule(schedule)"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="bg-danger text-white"
                      >
                        <use xlink:href="#icon-close"/>
                      </svg>
                    </button>
                  </li>
                </ul>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import {days} from "@/constants/months";
import PageTitle from '@/common/components/PageTitle'
import BtnClose from '@/common/components/BtnClose'

export default {
  components:{PageTitle, BtnClose},
  data() {
    return {
      schedules: [],
      dialog: false,
      form: {
        day: 1,
        begin: '10:00',
        end: '11:00',
      },
      begin_modal: false,
      end_modal: false,
      days,
    }
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.$emit('closeModal')
      }
    }
  },
  mounted() {
    if (this.$route.query.show_create_schedule) {
      this.dialog = true;
    }
    this.getSchedules()
      .then(r => {
        this.schedules = r.data.data
      })
  },
  methods: {
    saveSchedule() {
      return axios.post('/api/v1/student/schedule', this.form)
        .then(r => {
          this.schedules.push(r.data.data);
          this.updateAuthUserHasSchedules();
          this.$emit('created-schedule');
        });
    },
    getSchedules() {
      return axios.get('/api/v1/student/schedule')
    },
    deleteSchedule(schedule) {
      return axios.delete(`/api/v1/student/schedule/${schedule.id}`)
        .then(() => {
          this.schedules = this.schedules.filter(s => s.id !== schedule.id)
        })
    },
    updateAuthUserHasSchedules() {
      const user = this.$store.state.auth.user;
      user.has_schedule = true;
      this.$store.commit('SET_AUTH_USER', user);
    }
  }

}
</script>

<style>
.schedule-icon svg {
  width: 24px;
  height: 24px;
  background-color: #E4E5E9;
  border-radius: 50%;
  padding: .4em;
}
</style>
